import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { formatCurrency } from 'src/utils/currency';
import { convertMilesToKilometers } from 'src/utils/unitSystemUtils';

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(2),
  },
  fontWeightMedium: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  cardHeader: {
    color: theme.palette.secondary.main,
  },
}));


function PolicyInfo({
  memberNumber,
  agencyCode,
  policyNumber,
  productNumber,
  planNumber,
  maxCoverageMiles,
  maxCoverageCosts,
  isMetric
}) {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardHeader
        className={classes.cardHeader}
        title="Policy Info"
      />
      <Divider />
      <Table>
        <TableBody>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>Policy Number</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary">
                {policyNumber}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>Member Number</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary">
                {memberNumber}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>Agency Code</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary">
                {agencyCode}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>Plan Number</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary">
                {planNumber}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>Product Number</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary">
                {productNumber}
              </Typography>
            </TableCell>
          </TableRow>
          {maxCoverageMiles ? (
            <TableRow>
              <TableCell className={classes.fontWeightMedium}>Max Coverage {isMetric ? 'Kilometers' : 'Miles'}</TableCell>
              <TableCell align="right">
                <Typography variant="body2" color="textSecondary">
                  {isMetric ? convertMilesToKilometers(maxCoverageMiles) : maxCoverageMiles}
                </Typography>
              </TableCell>
            </TableRow>
          ) : null}
          {maxCoverageCosts ? (
            <TableRow>
              <TableCell className={classes.fontWeightMedium}>Max Coverage Cost</TableCell>
              <TableCell align="right">
                <Typography variant="body2" color="textSecondary">
                  {formatCurrency(maxCoverageCosts)}
                </Typography>
              </TableCell>
            </TableRow>
          ) : null}
        </TableBody>
      </Table>
    </Card>
  );
}

PolicyInfo.defaultProps = {
  memberNumber: '',
  agencyCode: '',
  policyNumber: '',
  productNumber: '',
  planNumber: '',
};

PolicyInfo.propTypes = {
  memberNumber: PropTypes.string,
  agencyCode: PropTypes.string,
  policyNumber: PropTypes.string,
  productNumber: PropTypes.string,
  planNumber: PropTypes.string,
  maxCoverageMiles: PropTypes.number,
  maxCoverageCosts: PropTypes.number,
  isMetric: PropTypes.bool.isRequired,
};

export default PolicyInfo;
